// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useAppOptions } from '../context/AppContext';
import { Box, Button, Grid, Typography } from '../lib/base';
import { FacebookIcon, InstagramIcon } from '../lib/icons';
import { CardView } from '../lib/layout';
import { Link } from '../lib/link';
import * as routes from '../routes';
// import { utils } from '@seedplanner/shared-utils';

export default function Pricing() {
  const navigate = useNavigate();
  const appOptions = useAppOptions();
  // const [email, setEmail] = React.useState('');
  // const [emailValidation, setEmailValidation] = React.useState('');
  // const [firstName, setFirstName] = React.useState('');
  // const [firstNameValidation, setFirstNameValidation] = React.useState('');
  // const [lastName, setLastName] = React.useState('');
  // const [lastNameValidation, setLastNameValidation] = React.useState('');
  // const onChangeFirstName = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   setFirstName(event.target.value);
  //   setFirstNameValidation('');
  // };
  // const onFirstNameBlur = () => {
  //   if (firstName === '') {
  //     setFirstNameValidation('First Name is required');
  //   } else {
  //     setFirstNameValidation('');
  //   }
  // };
  // const onChangeLastName = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   setLastName(event.target.value);
  //   setLastNameValidation('');
  // };
  // const onLastNameBlur = () => {
  //   if (lastName === '') {
  //     setLastNameValidation('Last Name is required');
  //   } else {
  //     setLastNameValidation('');
  //   }
  // };
  // const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   setEmail(event.target.value);
  //   setEmailValidation('');
  // };
  // const onEmailBlur = () => {
  //   if (email === '') {
  //     setEmailValidation('Email is required');
  //   } else if (utils.emailRegex.test(email) === false) {
  //     setEmailValidation('Email is invalid');
  //   } else {
  //     setEmailValidation('');
  //   }
  // };

  // const loading = false;
  // const submitDisabled =
  //   firstName === '' ||
  //   lastName === '' ||
  //   email === '' ||
  //   loading ||
  //   firstNameValidation !== '' ||
  //   lastNameValidation !== '' ||
  //   emailValidation !== '';
  // const fieldsDisabled = loading;

  return (
    <CardView title="Pricing">
      <Helmet>
        <title>{'Pricing'}</title>
        <meta name="description" content={'Currently in the free beta phase! Read more about our plans for pricing.'} />
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          p: 3,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Our Pricing Plan
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          Join us in the Beta Phase!
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '600px', textAlign: 'center' }}>
          Microgreen Manager is currently in beta and completely free to use. All features are currently available to
          you and are expected to work without issue. The software is free for the time being as we continue to build
          the product, collect feedback, and add features.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          Why is it free?
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '600px', textAlign: 'center' }}>
          We are still building Microgreen Manager. We have high expectations for ourselves and will not charge for the
          software until we are confident that it is something worthy of your hard-earned money.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          When will you start charging?
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '600px', textAlign: 'center' }}>
          With that being said, we are a business and we will need to charge for our product at some point. We don't
          know exactly when this will be, but when that time comes, we will notify you well in advance through email and
          social media. All existing users will be given at least a 30-day free trial before being charged.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          What will the price be?
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '600px', textAlign: 'center' }}>
          We plan to introduce a subscription model at around $15-$25/month. We have not determined the exact price yet,
          because we are simply too busy building the product! By joining us now, you can help shape the future of
          Microgreen Manager and enjoy early access.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          Will there be a free tier?
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '600px', textAlign: 'center' }}>
          Yes! We plan to offer a free tier for hobbyists and small growers at some point. This tier will have limited
          features and will be free forever.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          Where can I get updates?
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '600px', textAlign: 'center' }}>
          You can follow us on social media! We will notify you of any changes to our pricing or the software itself.
        </Typography>
        <Grid container justifyContent="center" alignItems="center" xs={12} columnSpacing={1}>
          <Grid xs={12}>
            <Grid container justifyContent="center" flexWrap="nowrap" spacing={0}>
              <Grid sx={{ pr: 0.5 }} xs="auto">
                {<InstagramIcon />}
              </Grid>
              <Grid xs="auto">
                <Link newTab path={appOptions.meta.social.instagram} title={'Instagram'} absolute />
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12}>
            <Grid container justifyContent="center" flexWrap="nowrap" spacing={0}>
              <Grid sx={{ pr: 0.5 }} xs="auto">
                {<FacebookIcon />}
              </Grid>
              <Grid xs="auto">
                <Link newTab path={appOptions.meta.social.fb} title={'Facebook'} absolute />
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid xs={12}>
            <Grid xs={12}>
              <TextField
                aria-describedby="first-name-input"
                id="first-name-input"
                label="First Name"
                required
                value={firstName}
                onChange={onChangeFirstName}
                onBlur={onFirstNameBlur}
                disabled={fieldsDisabled}
                hasSubtext
                subtext={firstNameValidation}
                error={firstNameValidation !== ''}
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                aria-describedby="last-name-input"
                id="last-name-input"
                label="Last Name"
                required
                value={lastName}
                onChange={onChangeLastName}
                onBlur={onLastNameBlur}
                disabled={fieldsDisabled}
                hasSubtext
                subtext={lastNameValidation}
                error={lastNameValidation !== ''}
              />
            </Grid>
            <Grid xs={12}>
              <TextField
                aria-describedby="email-input"
                id="email-input"
                label="Email"
                inputMode="email"
                type="email"
                required
                value={email}
                onChange={onChangeEmail}
                disabled={fieldsDisabled}
                onBlur={onEmailBlur}
                hasSubtext
                subtext={emailValidation}
                error={emailValidation !== ''}
              />
            </Grid>
          </Grid> */}
        </Grid>
        <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={() => navigate(routes.SIGNUP)}>
          Sign Up For The Free Beta
        </Button>
      </Box>
    </CardView>
  );
}
